import { SVGProps } from "react";

export default function FolderIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#667084", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.66797 10.85V5.83332C1.66797 2.49999 2.5013 1.66666 5.83464 1.66666H7.08464C8.33464 1.66666 8.60963 2.03332 9.08463 2.66666L10.3346 4.33332C10.6513 4.74999 10.8346 4.99999 11.668 4.99999H14.168C17.5013 4.99999 18.3346 5.83332 18.3346 9.16666"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3346 12.4917V14.1667C18.3346 17.5 17.5013 18.3333 14.168 18.3333H5.83464C2.5013 18.3333 1.66797 17.5 1.66797 14.1667"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
